<template>
    <div>
        <div class="items_list white">
            <div class="item" v-for="chatGroup in chatGroups"
                 :key="chatGroup.id"
                 @click="handleClickChatGroup(chatGroup)"
            >
                <span class="text">
                  {{chatGroup.company.short_name}}<span class="ml-2">{{chatGroup.maker_product_name}}</span>
                </span>
                <span class="badge chat_group" v-if="chatGroup.total_unread_messages > 0">
                    {{chatGroup.total_unread_messages}}
                </span>
                <div class="item_button button button_small button_rounded bordered deep_blue"
                     @click.stop="showParticipants(chatGroup)">
                    <span class="icon icon_users_group"></span> メンバー
                </div>
            </div>

            <infinite-loading @infinite="paginate">
                <div slot="spinner"></div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </div>

        <Modal :title="modal.title"
            :content="modal.content"
            type="chat-group"
            v-show="modal.show"
            @cancel="modal.show = false"
        />
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import ChatGroupApi from '@/api/chat-group'
  import InstitutionApi from '@/api/institution'
  import firebase, {db} from '@/firebase'
  import {makeChatGroupDataForFirebase} from '@/helpers'
  import Modal from '@/components/modal'
  import _ from 'lodash'

  export default {
    components: {
      Modal
    },
    data () {
      return {
        institution: {},
        chatGroups: [],
        modal: {
          show: '',
          title: '',
          content: ''
        },
        subscribeChatGroup: null
      }
    },
    methods: {
      ...mapActions({
        setLinks: 'navigator/setLinks',
        getParticipateChatGroups: 'institution/getParticipateChatGroups',
        setFineplay: 'navigator/setFineplay',
        clearUnreadMessages: 'institution/clearUnreadMessages'
      }),
      async handleClickChatGroup (chatGroup) {
        const snapshot = await firebase.getChatGroup(chatGroup.id)
        const snapshotInstitution = await firebase.getInstitution(this.institution.institution_code)

        if (!snapshot.exists()) {
          await firebase.storeChatGroup(chatGroup.id, makeChatGroupDataForFirebase({chatGroup, lastMessage: ''}))
        }
        if (!snapshotInstitution.exists()) {
          await firebase.storeInstitution(this.institution.institution_code, {total: this.institution.total_unread_messages})
        }

        this.$router.push({name: 'chat', params: {chatGroupId: chatGroup.id}})

        this.clearUnreadMessages({
          institutionCode: this.institution.institution_code,
          total: chatGroup.total_unread_messages
        })
      },
      async setNavigatorLinks () {
        const res = await InstitutionApi.show(this.$route.params.institutionCode)
        this.institution = res.data.data
        this.setLinks([{title: this.institution.abbreviated_name_kanji, route: {name: 'home'}}])
      },
      paginate ($state) {
        setTimeout(async () => {
          const res = await ChatGroupApi.get({
            institution_code: this.$route.params.institutionCode,
            offset: this.chatGroups.length
          })
          this.chatGroups = [...this.chatGroups, ...res.data.data]
          this.chatGroups = _.sortBy(this.chatGroups, ['company_code', 'maker_product_code'])
        })
      },
      showParticipants (chatGroup) {
        this.modal.show = true
        this.modal.title = `${chatGroup.company.short_name} ${chatGroup.market_code}`
        let content = ''
        chatGroup.employees.forEach(n => {
          content += `${n.company_code} ${n.name_kanji}<br>`
        })
        this.modal.content = content
      }
    },
    async mounted () {
      await this.setNavigatorLinks()
      this.setFineplay(false)

      this.subscribeChatGroup = db.ref(`chat_groups`)
      this.subscribeChatGroup.on('child_changed', (data) => {
        const index = this.chatGroups.findIndex(n => n.id === parseInt(data.key))
        if (index !== -1) {
          if (data.val().total > this.chatGroups[index].total_messages) {
            this.chatGroups[index].total_unread_messages = this.chatGroups[index].total_unread_messages + 1
            this.chatGroups[index].total_messages = this.chatGroups[index].total_messages + 1
          }
        }
      })
    },
    beforeDestroy () {
      this.subscribeChatGroup.off()
    }
  }
</script>




// WEBPACK FOOTER //
// src/screens/institutions/show.vue